<template>
  <div class="RecordBox">
    <un-has-violation
      v-if="isLoad && finished && total === 0"
      :tipText="
        totalViolationpCount === 0
          ? '暂无违规记录，<br>请继续保持哦~'
          : '暂无违规记录，<br>请继续保持哦~'
      "
    >
    </un-has-violation>
    <div v-else class="hasViolation">
      <div>
        <div class="title">你共有{{ total }}次违规记录</div>
        <van-list
          v-model="currentLoading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="listBox">
            <recordList :list="list" />
          </div>
          <template #finished>
            <segement-Line line-text="没有更多数据啦"> </segement-Line>
          </template>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, Icon, List } from "vant";
import recordList from "../../components/recordList";
import UnHasViolation from "./UnHasViolation.vue";
import SegementLine from "@/components/puppetComponent/SegementLine";
export default {
  name: "Record",
  components: {
    recordList,
    "van-cell": Cell,
    "van-icon": Icon,
    "van-list": List,
    UnHasViolation,
    SegementLine
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    total: {
      type: Number || String,
      default: () => {
        return 0;
      },
    },
    totalViolationpCount: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    loading: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    finished: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      currentLoading: false
    };
  },
  watch: {
    loading (val) {
      this.currentLoading = val
    }
  },
  methods: {
    onLoad () {
      this.$emit('loadMore')
    }
  }
};
</script>

<style lang="scss" scoped>
.hasViolation {
  .title {
    color: #888888;
    font-size: 14px;
    padding: 11px 16px;
    color: #999999;
  }
  .listBox {
    background-color: #fff;
  }
}
</style>
